<template>
  <div v-if="!openOtherSite">
    <v-app id="home-app" v-if="$mq !== 'xs'">
      <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
      <v-navigation-drawer v-model="drawer" fixed right app v-bind:disable-resize-watcher="true">
        <v-list dense class="pt-0">
          <v-list-tile v-on:click="scroll('#home')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Home')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#qb')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('QuickBe')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#partner')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString(`Per l'esercente`)}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#clients')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Per i clienti')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#apps')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Le App')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#prices')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Prezzi')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#contacts')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Contattaci')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="$router.push('/roadmap')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Roadmap')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar class="elevation-4 gray grey lighten-4" fixed app>
        <v-toolbar-title>{{printCurrentPage}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat v-on:click="scroll('#home')">{{getString('Home')}}</v-btn>
          <v-btn flat v-on:click="scroll('#qb')">{{getString('QuickBe')}}</v-btn>
          <v-btn flat v-on:click="scroll('#partner')">{{getString(`Per l'esercente`)}}</v-btn>
          <v-btn flat v-on:click="scroll('#clients')">{{getString('Per i clienti')}}</v-btn>
          <v-btn flat v-on:click="scroll('#apps')">{{getString('Le App')}}</v-btn>
          <v-btn flat v-on:click="scroll('#prices')">{{getString('Prezzi')}}</v-btn>
          <v-btn flat v-on:click="scroll('#contacts')">{{getString('Contattaci')}}</v-btn>
          <v-btn flat v-on:click="$router.push('/roadmap')">{{getString('Roadmap')}}</v-btn>
        </v-toolbar-items>
        <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar>
      <v-content style="margin-bottom:150px;">
        <header-p></header-p>
        <section id="qb">
          <v-layout column wrap class="my-5" align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <h1 class="q-headline">{{getString(`QuickBe, l'app per prenotare più innovativa!`)}}</h1>
                <span
                  class="subheading"
                >{{getString(`L'innovazione e la gestione delle tue prenotazioni con un'app a portata di click`)}}</span>
                <v-divider class="text-divider"></v-divider>
                <p
                  style="max-width:800px;margin:auto;"
                  v-html="getString(`QuickBe è un sistema in <b>tempo reale</b> per gestire attraverso un calendario dedicato tutte le tue prenotazioni! Gestisci al meglio il tuo tempo, semplifica la vita ai tuoi clienti e rafforza il <b>tuo brand</b> grazie alla tecnologia.`)"
                ></p>
                <p
                  style="max-width:800px;margin:auto;"
                  v-html="getString(`QuickBe infatti ti offre, oltre a far parte di una rete di professionisti, la possibilità di avere un sito totalmente gratuito su <b>QuickBe Plaza</b> insieme ad un piano ove è presente un'app <b>dedicata al tuo brand</b>.`)"
                ></p>
                <p
                  style="max-width:800px;margin:auto;"
                  v-html="getString(`Ci trovi anche su <a class='a' title='Facebook' href='https://www.facebook.com/QuickBeApp/' target='_new'>Facebook</a> ed <a class='a' title='instagram' href='https://www.instagram.com/quickbeapp/' target='_new'>Instagram</a>! Cosa aspetti? Prenotare non è mai stato così facile!`)"
                ></p>
                <v-divider class="text-divider"></v-divider>
                <p
                  style="max-width:800px;margin:auto;"
                  v-html="getString(`Sei un <b>fornitore</b> dei professionisti che serviamo o un <b>commerciale</b>? Contattaci per scoprire i nostri contratti di collaborazione.`)"
                ></p>
                <router-link class="a" to="/legal/affil">{{getString('Informazioni commerciali')}}</router-link>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="service">
                      <v-img
                        src="~/../../../static/img/card1.jpg"
                        alt="Photo by rawpixel on Unsplash"
                        height="200"
                      ></v-img>
                      <v-card-title primary-title>
                        <div>
                          <h3 class="headline mb-0">{{getString(`In un Quick!`)}}</h3>
                          <p
                            v-html="getString('<b>Prenotarsi</b> non è mai stato così facile. Col <b>tuo smartphone</b> prenota dal tuo professionista preferito.')"
                          ></p>
                        </div>
                      </v-card-title>
                      <v-card-actions class="serviceAction">
                        <v-btn
                          flat
                          class="q-orange"
                          @click="scroll('#apps')"
                        >{{getString('Vai alle app')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="service">
                      <v-img
                        alt="Photo from web"
                        src="~/../../../static/img/card0.jpg"
                        height="200"
                      ></v-img>
                      <v-card-title primary-title>
                        <div>
                          <h3 class="headline mb-0">{{getString(`QuickBe PLAZA`)}}</h3>
                          <p
                            v-html="getString('Uno spazio web dedicato al <b>tuo negozio</b>, ricercabile dai clienti, <b>gratis</b> e personalizzabile! Cosa vuoi di più?')"
                          ></p>
                        </div>
                      </v-card-title>
                      <v-card-actions class="serviceAction">
                        <v-btn
                          flat
                          class="q-orange"
                          @click="goToPlaza"
                        >{{getString('Esplora su QuickBe Plaza')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="service">
                      <v-img
                        src="~/../../../static/img/card2.jpg"
                        alt="Photo by Ewout Paulusma on Unsplash"
                        height="200"
                      ></v-img>
                      <v-card-title primary-title>
                        <div>
                          <h3 class="headline mb-0">{{getString(`Non sei convinto?`)}}</h3>
                          <p
                            v-html="getString('Oltre al piano <b>FREE</b>, ti offriamo un mese <b>GRATUITO</b> di prova senza alcun tipo di limitazione! Cosa aspetti?')"
                          ></p>
                        </div>
                      </v-card-title>
                      <v-card-actions class="serviceAction">
                        <v-btn
                          flat
                          class="q-orange"
                          @click="goToReg"
                        >{{getString('Fai la prova gratuita')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="service">
                      <v-img
                        src="~/../../../static/img/card4a.jpg"
                        alt="Photo by rawpixel on Unsplash"
                        height="200"
                      ></v-img>
                      <v-card-title primary-title>
                        <div>
                          <h3 class="headline mb-0">{{getString(`Risparmia!`)}}</h3>
                          <p
                            v-html="getString('QuickBe ha solo un costo <nessuna>fisso, nessuna commissione sulle prenotazioni</b> o altro!')"
                          ></p>
                        </div>
                      </v-card-title>
                      <v-card-actions class="serviceAction">
                        <v-btn
                          v-on:click="scroll('#prices')"
                          flat
                          class="q-orange"
                        >{{getString('Vedi i piani')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </section>
        <section id="partner" class="q-orange-bk-image q-text-whitesmoke">
          <v-layout column wrap class="my-5" align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <span class="myh2">{{`Per l'esercente`}}</span>
                <span
                  class="subheading"
                >{{`L'innovazione e la gestione delle tue prenotazioni a portata di click`}}</span>
              </div>
            </v-flex>
            <v-flex xs12 md12>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large>calendar_today</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="q-headline text-xs-center">{{getString('Prenotazioni')}}</div>
                      </v-card-title>
                      <v-card-text>{{getString('QuickBe ti offre un calendario per le prenotazioni interattivo, con notifiche in tempo reale e possibilità di modifica.')}}</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large>store_mall_directory</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="q-headline text-xs-center">{{getString('Il tuo negozio')}}</div>
                      </v-card-title>
                      <v-card-text>{{getString('Orari di apertura, giorni di apertura, gestione dipendenti, galleria foto, listini prezzi, etc. Mostra al meglio il tuo negozio.')}}</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large>bar_chart</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="q-headline text-xs-center">{{getString('Statistiche')}}</div>
                      </v-card-title>
                      <v-card-text>{{getString('Accedi alle statistiche per il negozio, le prenotazioni, gli utenti, etc. Puoi anche scegliere di renderle private in modo da accedervi solo tu!')}}</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large>smartphone</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="q-headline text-xs-center">{{getString('App dedicate')}}</div>
                      </v-card-title>
                      <v-card-text>{{getString('Oltre alla tua presenza sulla nostra app, QuickBe ti permette di avere app dedicate con il tuo brand! Richiedi subito informazioni!')}}</v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs12 sm4 class="my-3">
              <v-btn
                class="white q-orange mt-5"
                dark
                large
                @click="scroll('#register')"
              >{{getString('Cosa aspetti? Registrati subito!')}}</v-btn>
            </v-flex>
          </v-layout>
        </section>
        <section id="video" v-if="notSafari">
          <div class="rwd-video">
            <iframe
              src="https://www.youtube.com/embed/tVFcjSBS_1U"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </section>
        <section id="customers" v-show="shops.length > 0">
          <v-layout column wrap class="my-5" align-center>
            <v-flex xs12 sm4 class="my-3">
              <h3 class="q-orange myh1 q-headline text-xs-center">{{`I negozi convenzionati`}}</h3>
              <swiper ref="mySwiper" v-if="shops.length > 0" :options="swiperOption">
                <!-- <div class="parallax-bg" slot="parallax-bg" data-swiper-parallax="-23%"></div> -->
                <!-- slides -->
                <swiper-slide v-for="(item, i) in shops" :key="i">
                  <div class="card-shop">
                    <span class="myh2">{{item.name}}</span>
                    <h3>{{item.city}}</h3>
                  </div>
                </swiper-slide>

                <!-- Optional controls -->
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>-->
              </swiper>
            </v-flex>
          </v-layout>
        </section>
        <section id="clients">
          <v-layout column wrap class="my-5" align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <span class="myh2">{{'Per il cliente'}}</span>
                <span
                  class="subheading"
                >{{`Trovare i professionisti della bellezza non è mai stato così facile`}}</span>
              </div>
            </v-flex>
            <v-flex xs12 md12>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 lg3>
                    <v-card :class="{'testVisClass' : !testVis}" class="elevation-4 q-orange-bk">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large class="q-text-whitesmoke">event</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="q-headline q-text-whitesmoke">{{getString('Prenotazioni')}}</div>
                      </v-card-title>
                      <v-card-text
                        class="q-text-whitesmoke"
                      >{{getString('QuickBe ti permette di scegliere il tuo professionista preferito e di prenotarti in pochissimi tap.')}}</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4 q-orange-bk">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large class="q-text-whitesmoke">person</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div
                          class="q-headline q-text-whitesmoke text-xs-center"
                        >{{getString('Il tuo profilo')}}</div>
                      </v-card-title>
                      <v-card-text
                        class="q-text-whitesmoke"
                      >{{getString('Puoi gestire i dati del tuo profilo, la tua foto o addirittura accedere direttamente con Facebook.')}}</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4 q-orange-bk">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large class="q-text-whitesmoke">subject</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div
                          class="q-headline q-text-whitesmoke text-xs-center"
                        >{{getString('Dettagli')}}</div>
                      </v-card-title>
                      <v-card-text
                        class="q-text-whitesmoke"
                      >{{getString('Tutte le informazioni riguardo il tuo professionsta che cerchi, compresi contatti, facebook e altro.')}}</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 lg3>
                    <v-card class="elevation-4 q-orange-bk">
                      <v-card-text class="text-xs-center">
                        <v-icon x-large class="q-text-whitesmoke">devices_other</v-icon>
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div
                          class="q-headline q-text-whitesmoke text-xs-center"
                        >{{getString('Multi piattaforma')}}</div>
                      </v-card-title>
                      <v-card-text
                        class="q-text-whitesmoke"
                      >{{getString(`QuickBe fornisce l'App sia per iOS che Android! Non preoccuparti quindi, puoi prenotarti ovunque!`)}}</v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>

          <v-parallax
            class="fit-image"
            src="~/../../../static/img/calendar.jpg"
            alt="Header"
            title="Photo by rawpixel on Unsplash"
            contain="true"
            style="height:300px"
          ></v-parallax>

          <v-layout id="apps" column wrap class="my-5" align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <span class="myh2">{{'Scarica le nostre app'}}</span>
                <span class="subheading">{{`Vai sullo store e scarica QuickBe`}}</span>
              </div>
            </v-flex>
            <v-container fluid>
              <v-layout column justify-center>
                <v-flex xs12>
                  <v-layout row wrap justify-center>
                    <a
                      target="_blank"
                      title="To Play Store"
                      href="https://play.google.com/store/apps/details?id=eu.dewstudio.quickbe"
                    >
                      <img
                        alt="play-store"
                        style="margin:10px"
                        height="100px"
                        src="~/../../../static/img/googleplay.png"
                      >
                    </a>
                    <a
                      title="To Apple Store"
                      target="_blank"
                      href="https://itunes.apple.com/it/app/quickbe/id1380749173?l=it&ls=1&mt=8&fbclid=IwAR2ep3_86W2t4ioSz3-D5lb38zdoLhg0PaOMToSo8LBlTXIENQxJZdhZcUc"
                    >
                      <img
                        style="margin:10px"
                        alt="apple-store"
                        height="100px"
                        src="~/../../../static/img/ios.png"
                      >
                    </a>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-layout>
        </section>
        <section id="prices">
          <v-layout column wrap class="my-3" align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <span class="myh2">{{getString('Piani per QuickBe!')}}</span>
                <span
                  class="subheading"
                >{{getString(`Ecco i piani che QuickBe offre`)}}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex xs12 sm12 md10 lg12>
              <v-container grid-list-xl>
                <v-layout row wrap >
                  <!-- <v-flex xs12 sm12 md12 lg4>
                    <v-card>
                      <v-toolbar class="free-bk price-table" dark>
                        <div style="width:100%; justify-content: left; display:flex;">
                          <span style="font-size:30px;font-weight:lighter;">{{getString('Free')}}</span>
                        </div>
                        <v-img
                          alt="free-sub"
                          class="border-white"
                          width="90px"
                          height="90px"
                          src="~/../../../static/img/ICON-free.png"
                        ></v-img>
                      </v-toolbar>
                      <v-list two-line>
                        <template v-for="(item, index) in compItemsMonth">
                          <span
                            style="text-align:center; margin-top:20px; margin-bottom:20px;font-size:30px;font-weight:lighter"
                            v-if="item.header"
                            :key="item.header"
                          >{{item.header}}</span>
                          <v-divider v-else-if="item.divider" :key="index"></v-divider>
                          <v-list-tile v-else :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title v-html="item.title"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-card>
                  </v-flex> -->
                  <v-flex xs12 sm12 md12 lg6>
                    <v-card>
                      <v-toolbar class="silver-bk price-table" dark>
                        <div style="width:100%; justify-content: left; display:flex">
                          <span style="font-size:30px;font-weight:lighter;">{{getString('Silver')}}</span>
                        </div>
                        <v-img
                          alt="silver-sub"
                          class="border-white"
                          width="90px"
                          height="90px"
                          src="~/../../../static/img/ICON-silver.png"
                        ></v-img>
                      </v-toolbar>
                      <v-list two-line>
                        <template v-for="(item, index) in compItemsSem">
                          <span
                            style="text-align:center; margin-top:20px; margin-bottom:20px;margin-left:10px;font-size:30px;font-weight:lighter"
                            v-if="item.header"
                            :key="item.header"
                          >{{item.header}}</span>
                          <v-divider v-else-if="item.divider" :key="index"></v-divider>
                          <v-list-tile v-else :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title v-html="item.title"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg6>
                    <v-card>
                      <v-toolbar class="platinum-bk price-table" dark>
                        <div style="width:100%; justify-content: left; display:flex">
                          <span
                            style="font-size:30px;font-weight:lighter;"
                          >{{getString('Platinum')}}</span>
                        </div>
                        <v-img
                          img="plat-sub"
                          class="border-white"
                          width="90px"
                          height="90px"
                          src="~/../../../static/img/ICON-platinum.png"
                        ></v-img>
                      </v-toolbar>
                      <v-list two-line>
                        <template v-for="(item, index) in compItemsYear">
                          <span
                            style="text-align:center; margin-top:20px; margin-left:10px; margin-bottom:20px;font-size:30px;font-weight:lighter"
                            v-if="item.header"
                            :key="item.header"
                          >{{item.header}}</span>
                          <v-divider v-else-if="item.divider" :key="index"></v-divider>
                          <v-list-tile v-else :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title v-html="item.title"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <v-layout column align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <span class="myh2">{{getString('Nessun costo nascosto!')}}</span>
                <v-divider class="text-divider"></v-divider>
                <span class="myh2">{{getString('Nessuna commissione sulle prenotazioni!')}}</span>
                <v-divider class="text-divider"></v-divider>
                <span
                  class="subheading"
                >{{getString(`Prova oggi stesso il servizio senza impegno e senza nessuna limitazione per`)}}</span>
                <span style="font-size:30px;color:red;font-weight:bold">{{getString(' un mese!')}}</span>
              </div>
            </v-flex>
          </v-layout>
        </section>
        <v-divider style="margin-bottom:30px"></v-divider>
        <section id="contacts">
          <v-layout style="padding-left:20px;padding-right:20px">
            <v-flex xs12 sm10 offset-sm1 md10 offset-md-1 offset-lg3 lg6>
              <v-card>
                <v-toolbar class="q-orange-bk white--text">
                  <div style="width:100%; justify-content: center; display:flex">
                    <span style="font-size:30px;font-weight:lighter;">{{getString('Contattaci')}}</span>
                  </div>
                </v-toolbar>
                <v-card-title primary-title>
                  <div style="margin-left:10px">
                    <h3
                      class="headline mb-0"
                    >{{getString('Usa il seguente form per richiedere informazioni oppure chiama al numero ')}}</h3>
                    <h2>081 180 96 075</h2>                    
                    <div>
                      <b>{{getString(`N.B.`)}}</b>
                      {{getString(' alcuni campi sono obbligatori*')}}
                    </div>
                  </div>
                </v-card-title>
                <v-form>
                  <v-layout row wrap>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container>
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="name"
                          :rules="nameRules"
                          v-bind:label="getString('Nome')"
                          v-bind:hint="getString('Il tuo nome')"
                          required
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container>
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="surname"
                          :rules="nameRules"
                          v-bind:label="getString('Cognome')"
                          v-bind:hint="getString('Il tuo cognome')"
                          required
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container>
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="email"
                          :rules="emailRules"
                          label="E-mail"
                          v-bind:hint="getString('Il campo deve essere un indirizzo email valido, per esempio: elcarro@carriage.xyz')"
                          required
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container>
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="shop"
                          v-bind:label="getString('Nome Negozio')"
                          v-bind:hint="getString('Il nome del tuo negozio (facoltativo)')"
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 md12>
                      <v-container>
                        <v-textarea
                          solo
                          v-bind:disabled="sended"
                          v-bind:label="getString('Messaggio')"
                          v-model="message"
                        ></v-textarea>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg5>
                      <v-container>
                        <label>{{getString('Per cortesia, indica come ci hai conoscito')}}</label>
                        <v-select
                          solo
                          color="#212121"
                          v-bind:disabled="sended"
                          v-model="select"
                          :items="knowledge"
                          v-bind:label="getString('Come ci hai conosciuto?')"
                        ></v-select>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12>
                      <v-container>
                        <label
                          v-html="getString(`Qui trovi i <a title='Termini e condizioni' href='/legal/tec'>Termini e Condizioni</a> per il trattamento dati. Leggili ed accetta per inviare il messaggio in piena consapevolezza.`)"
                        ></label>
                        <v-checkbox
                          :label="getString('Accetto')"
                          v-model="accept"
                          v-bind:disabled="sended"
                        ></v-checkbox>
                      </v-container>
                    </v-flex>
                    <v-flex xs12>
                      <div style="margin-left:25px" id="g-recaptcha"></div>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-card-actions>
                  <v-container>
                    <v-btn
                      v-if="!sended"
                      :disabled="!valid"
                      @click="sendForm()"
                      class="q-orange"
                    >{{getString('Invia')}}</v-btn>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout column id="register">
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <v-divider class="text-divider"></v-divider>
                <span
                  class="myh2"
                >{{getString('Oppure inviaci la tua registrazione direttamente!')}}</span>
                <span
                  class="subheading"
                >{{getString(`Una volta effettuati i check di base, ti verrà abilitato l'account e potrai configurarlo ed iniziare subito a far funzionare QuickBe`)}}</span>
                <v-container>
                  <v-btn
                    class="q-orange"
                    @click="goToReg"
                  >{{getString('Registrati')}}</v-btn>
                </v-container>
              </div>
            </v-flex>
          </v-layout>
        </section>
      </v-content>
      <v-footer dark height="auto" class=".footer">
        <v-card class="flex" flat tile>
          <v-card-title class="q-orange-bk">
            <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
            <v-spacer></v-spacer>
            <v-btn
              v-for="icon in icons"
              :key="icon.ic"
              class="mx-3"
              dark
              icon
              @click="navigate(icon.url)"
            >
              <v-icon size="24px">{{ icon.ic }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="grey darken-3 justify-center" style="text-align:center">
            &copy; 2018 - &copy;{{(new Date()).getFullYear()}} — &nbsp;
            <strong>Dew Studio P.Iva 09663761212</strong> &nbsp; — &nbsp;
            <a href="tel:08118096075">Tel. 081 180 96 075</a> &nbsp; — &nbsp;
            <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
            <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
            <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
            <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
            <router-link to="/admin/login">{{getString('Portale')}}</router-link>
          </v-card-text>
        </v-card>
      </v-footer>
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card class="q-whitesmoke-bk black--text" dark>
          <v-card-text>
            {{getString('Invio in corso')}}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSuccess" hide-overlay persistent width="300">
        <v-card class="green lighten-3" dark>
          <v-card-text>
            <h4>{{getString('Inviato con successo')}}</h4>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogError" hide-overlay persistent width="300">
        <v-card class="red lighten-1" dark>
          <v-card-text>
            <h4>{{getString('Errore nell\'invio, riprova più tardi')}}</h4>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogErrorMissing" hide-overlay persistent width="300">
        <v-card class="red lighten-1" dark>
          <v-card-text>
            <h4>{{getString('Campi mancanti')}}</h4>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Your customer chat code -->
      <div
        class="fb-customerchat"
        attribution="setup_tool"
        page_id="1391355074298712"
        theme_color="#d5725b"
      ></div>
    </v-app>
    <v-app id="home-app" v-if="$mq === 'xs'">
      <v-navigation-drawer v-model="drawer" fixed right app v-bind:disable-resize-watcher="true">
        <v-list dense class="pt-0">
          <v-list-tile v-on:click="scroll('#home')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Home')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#qb')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('QuickBe')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#partner')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString(`Per l'esercente`)}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#clients')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Per i clienti')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#apps')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Le App')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#prices')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Prezzi')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="scroll('#contacts')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Contattaci')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="$router.push('/roadmap')">
            <v-list-tile-content>
              <v-list-tile-title>{{getString('Roadmap')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-content style="margin-bottom:20px;padding:0">
        <v-img
          src="~/../../../static/img/m_logo.png"
          alt="Photo by rawpixel on Unsplash"
          title="Photo by rawpixel on Unsplash"
          class="header-logo"
        ></v-img>
        <section id="qb">
          <v-layout column wrap align-center>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center" style="padding:10px">
                <h1 class="m-header">{{getString(`QuickBe, l'innovazione per la tua attività!`)}}</h1>
                <span class="m-subheader">{{getString(`Le tue prenotazioni a portata di click`)}}</span>
                <div class="m-header-div">
                  <div style="width:65%">
                    <p
                      class="m-header-div-orange"
                      v-html="getString(`QuickBe è la piattaforma per la gestione delle prenotazioni.`)"
                    ></p>
                    <p
                      class="m-header-div-gray"
                      v-html="getString(`<b>Gestisci al meglio il tuo tempo,<br>semplifica la vita ai tuoi clienti <br>e rafforza il tuo brand grazie alla tecnologia.</b>`)"
                    ></p>
                  </div>
                </div>
                <div>
                  <span class="m-try-blue">{{getString("PROVA OGGI STESSO IL SERVIZIO")}}</span>
                  <span class="m-try-orange">{{getString("SENZA IMPEGNO E SENZA LIMITAZIONI")}}</span>
                  <span class="m-try-blue">{{getString("PER UN MESE!")}}</span>
                </div>
                <v-btn
                  class="m-button"
                  @click="goToReg"
                >{{getString("REGISTRATI GRATIS")}}</v-btn>
                <div style="margin-top:30px;">
                  <span class="m-header">{{getString("QuickBe è...")}}</span>
                  <div class="m-icon-container">
                    <div class="m-icon-row">
                      <div class="m-icon-ext">
                        <v-img src="~/../../../static/img/m_calendar.png"/>
                      </div>
                      <div class="m-icon-text">
                        <span class="m-try-blue m-uppercase">{{getString("GESTIONE PRENOTAZIONI")}}</span>
                        {{getString("Calendario interattivo, con notifiche in tempo reale e totale possibilità di gestione")}}
                      </div>
                    </div>
                    <!-- -->
                    <div class="m-icon-row">
                      <div class="m-icon-ext">
                        <v-img src="~/../../../static/img/m_setting.png"/>
                      </div>
                      <div class="m-icon-text">
                        <span class="m-try-blue m-uppercase">{{getString("GESTIONE NEGOZIO")}}</span>
                        {{getString("Orari e giorni di apertura, gestione dipendenti, galleria foto, listini prezzi, etc.")}}
                      </div>
                    </div>
                    <div class="m-icon-row">
                      <div class="m-icon-ext">
                        <v-img src="~/../../../static/img/m_statistic.png"/>
                      </div>
                      <div class="m-icon-text">
                        <span class="m-try-blue m-uppercase">{{getString("Statistiche attività")}}</span>
                        {{getString("Statistiche del tuo negozio, le prenotazioni, i clienti, i tuoi dipendenti, etc.")}}
                      </div>
                    </div>
                    <div class="m-icon-row">
                      <div class="m-icon-ext">
                        <v-img src="~/../../../static/img/m_app.png"/>
                      </div>
                      <div class="m-icon-text">
                        <span class="m-try-blue m-uppercase">{{getString("App dedicate")}}</span>
                        {{getString("QuickBe ti permette di avere app dedicate con il tuo brand! Richiedi subito informazioni!")}}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <span class="m-try-blue">{{getString("PROVA OGGI STESSO IL SERVIZIO")}}</span>
                  <span class="m-try-orange">{{getString("SENZA IMPEGNO E SENZA LIMITAZIONI")}}</span>
                  <span class="m-try-blue">{{getString("PER UN MESE!")}}</span>
                </div>
                <v-btn
                  class="m-button"
                  @click="goToReg"
                >{{getString("REGISTRATI GRATIS")}}</v-btn>
                <div style="margin-top:30px;">
                  <span class="m-header-alt">{{getString("Come funziona QuickBe?")}}</span>
                  <div class="m-hand-container">
                    <div
                      class="m-hand-text"
                    >{{getString("Scaricando l'App QuickBe i tuoi clienti potranno prenotarsi in totale autonomia scegliendo il trattamento, il dipendente, il giorno e l'orario in base alla tua disponibilità!")}}</div>
                    <div style="clear:both"></div>
                    <div
                      class="m-hand-text-1"
                    >{{getString("Riceverai notifica della prenotazione in tempo reale e potrai gestirla facilmente dal tuo calendario!")}}</div>
                    <div style="clear:both"></div>
                  </div>
                </div>
                <span class="m-header-alt">{{getString("L'App è disponibile per Android ed iOS")}}</span>
                <div style="clear:both"></div>
                <div class="m-app">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=eu.dewstudio.quickbe"
                  >
                    <img
                      style="width:167px; height:auto;"
                      height="100px"
                      src="~/../../../static/img/googleplay.png"
                    >
                  </a>
                  <a
                    target="_blank"
                    href="https://itunes.apple.com/it/app/quickbe/id1380749173?l=it&ls=1&mt=8&fbclid=IwAR2ep3_86W2t4ioSz3-D5lb38zdoLhg0PaOMToSo8LBlTXIENQxJZdhZcUc"
                  >
                    <img
                      style="width:150px; height:auto;"
                      height="100px"
                      src="~/../../../static/img/ios.png"
                    >
                  </a>
                </div>
                <div>
                  <span class="m-try-blue">{{getString("OFFRI AI TUOI CLIENTI")}}</span>
                  <span class="m-try-orange">{{getString("QUESTO SERVIZIO INNOVATIVO")}}</span>
                </div>
                <v-btn
                  class="m-button"
                  @click="goToReg"
                >{{getString("REGISTRATI GRATIS")}}</v-btn>
                <div style="margin-top:30px;">
                  <span class="m-header-1">{{getString("QuickBe non è solo App...")}}</span>
                  <div class="m-moon-container">
                    <div
                      class="m-moon-text"
                    >{{getString("QuickBe ti da la possibilità di entrare a far parte di una rete di professionisti, inoltre ti offre un sito totalmente gratuito su QuickBe Plaza.")}}</div>
                    <div style="clear:both"></div>
                    <div
                      class="m-moon-text-1"
                    >{{getString("Uno spazio web dedicato al tuo negozio, ricercabile dai clienti, gratis e personalizzabbile!")}}</div>
                    <div style="clear:both"></div>
                  </div>
                </div>
                <div>
                  <span class="m-try-blue">{{getString("INIZIA SUBITO IL TUO MESE DI PROVA")}}</span>
                  <span class="m-try-orange">{{getString("SENZA IMPEGNO")}}</span>
                  <span class="m-try-blue">{{getString("E SENZA NESSUNA LIMITAZIONE!")}}</span>
                </div>
                <v-btn
                  class="m-button"
                  @click="goToReg"
                >{{getString("REGISTRATI GRATIS")}}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </section>
        <section id="customers" v-show="shops.length > 0">
          <v-layout center column>
            <v-flex style="text-align:center" xs12 sm4>
              <span class="m-header">{{`I negozi convenzionati`}}</span>
              <swiper
                ref="mySwiper"
                style="margin-top:15px;"
                v-if="shops.length > 0"
                :options="swiperOption"
              >
                <!-- <div class="parallax-bg" slot="parallax-bg" data-swiper-parallax="-23%"></div> -->
                <!-- slides -->
                <swiper-slide v-for="(item, i) in shops" :key="i">
                  <div>
                    <span class="myh1 m-header-div-orange">{{item.name}}</span>
                    <h3>{{item.city}}</h3>
                  </div>
                </swiper-slide>

                <!-- Optional controls -->
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>-->
              </swiper>
            </v-flex>
          </v-layout>
        </section>
        <v-divider class="text-divider"></v-divider>
        <section id="prices">
          <v-layout column wrap class="my-3" align-center>
            <span class="m-header-alt">{{getString("Quanto costa QuickBe?")}}</span>
            <v-flex xs12 sm4 class="my-3">
              <div class="text-xs-center">
                <span
                  class="m-header-div-orange"
                >{{getString("Puoi scegliere il piano più adatto alle tue esigenze:")}}</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex xs12 sm12 md10 lg12>
              <v-container grid-list-xl>
                <v-layout row wrap>
                  <!-- <v-flex xs12 sm12 md12 lg4>
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <v-toolbar class="free-bk price-table" dark slot="header">
                          <div style="width:100%; justify-content: left; display:flex;">
                            <span style="font-size:30px;font-weight:lighter;">{{getString('Free')}}</span>
                          </div>
                          <v-img
                            class="border-white"
                            width="90px"
                            height="90px"
                            alt="free subs"
                            src="~/../../../static/img/ICON-free.png"
                          ></v-img>
                        </v-toolbar>
                        <v-card>
                          <v-list two-line>
                            <template v-for="(item, index) in compItemsMonth">
                              <span
                                style="text-align:center; margin-top:20px; margin-bottom:20px;font-size:30px;font-weight:lighter"
                                v-if="item.header"
                                :key="item.header"
                              >{{item.header}}</span>
                              <v-divider v-else-if="item.divider" :key="index"></v-divider>
                              <v-list-tile v-else :key="index">
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="item.title"></v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex> -->

                  <v-flex xs12 sm12 md12 lg4>
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <v-toolbar class="silver-bk price-table" dark slot="header">
                          <div style="width:100%; justify-content: left; display:flex">
                            <span
                              style="font-size:30px;font-weight:lighter;"
                            >{{getString('Silver')}}</span>
                          </div>
                          <v-img
                            class="border-white"
                            width="90px"
                            height="90px"
                            alt="silver subs"
                            src="~/../../../static/img/ICON-silver.png"
                          ></v-img>
                        </v-toolbar>
                        <v-card>
                          <v-list two-line>
                            <template v-for="(item, index) in compItemsSem">
                              <span
                                style="text-align:center; margin-left:10px; margin-top:20px; margin-bottom:20px;font-size:30px;font-weight:lighter"
                                v-if="item.header"
                                :key="item.header"
                              >{{item.header}}</span>
                              <v-divider v-else-if="item.divider" :key="index"></v-divider>
                              <v-list-tile v-else :key="index">
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="item.title"></v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg4>
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <v-toolbar class="platinum-bk price-table" dark slot="header">
                          <div style="width:100%; justify-content: left; display:flex">
                            <span
                              style="font-size:30px;font-weight:lighter;"
                            >{{getString('Platinum')}}</span>
                          </div>
                          <v-img
                            class="border-white"
                            width="90px"
                            height="90px"
                            alt="platinum subs"
                            src="~/../../../static/img/ICON-platinum.png"
                          ></v-img>
                        </v-toolbar>
                        <v-card>
                          <v-list two-line>
                            <template v-for="(item, index) in compItemsYear">
                              <span
                                style="text-align:center; margin-left:10px; margin-top:20px; margin-bottom:20px;font-size:30px;font-weight:lighter"
                                v-if="item.header"
                                :key="item.header"
                              >{{item.header}}</span>
                              <v-divider v-else-if="item.divider" :key="index"></v-divider>
                              <v-list-tile v-else :key="index">
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="item.title"></v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <v-layout column align-center style="padding:10px;text-align:center">
            <div>
              <span
                class="m-try-blue"
                style="margin-bottom:10px"
              >{{getString("NESSUN COSTO NASCOSTO")}}</span>
              <span
                class="m-try-orange"
                style="margin-bottom:10px"
              >{{getString("NESSUNA COMMISSIONE SULLE PRENOTAZIONI!")}}</span>
              <span
                class="m-try-blue"
                style="margin-bottom:10px"
              >{{getString("PROVARE NON TI COSTA NULLA...")}}</span>
            </div>
            <v-btn
              class="m-button"
              @click="goToReg"
            >{{getString("REGISTRATI GRATIS")}}</v-btn>
          </v-layout>
        </section>
        <section id="contacts">
          <v-layout style="padding-left:20px;padding-right:20px">
            <v-flex xs12 sm10 offset-sm1 md10 offset-md-1 offset-lg3 lg6>
              <span
                class="m-header-1"
                style="margin-bottom:20px;display:block; text-align:center"
              >{{getString("Vuoi maggiori informazioni?")}}</span>
              <v-card>
                <v-toolbar class="q-orange-bk white--text">
                  <div style="width:100%; justify-content: center; display:flex">
                    <span style="font-size:30px;font-weight:lighter;">{{getString('Contattaci')}}</span>
                  </div>
                </v-toolbar>
                <v-card-title primary-title>
                  <div style="margin-left:10px">
                    <h3
                      class="headline mb-0"
                    >{{getString('Usa il seguente form per richiedere informazioni oppure chiama')}}</h3>
                    <h2>081 180 96 075</h2>
                    <div>
                      <b>{{getString(`N.B.`)}}</b>
                      {{getString(' alcuni campi sono obbligatori*')}}
                    </div>
                  </div>
                </v-card-title>
                <v-form>
                  <v-layout row wrap>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="name"
                          :rules="nameRules"
                          v-bind:label="getString('Nome')"
                          v-bind:hint="getString('Il tuo nome')"
                          required
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="surname"
                          :rules="nameRules"
                          v-bind:label="getString('Cognome')"
                          v-bind:hint="getString('Il tuo cognome')"
                          required
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="email"
                          :rules="emailRules"
                          label="E-mail"
                          v-bind:hint="getString('Il campo deve essere un indirizzo email valido, per esempio: elcarro@carriage.xyz')"
                          required
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 md12 lg6 sm12>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <v-text-field
                          color="#212121"
                          v-bind:disabled="sended"
                          solo
                          v-model="shop"
                          v-bind:label="getString('Nome Negozio')"
                          v-bind:hint="getString('Il nome del tuo negozio (facoltativo)')"
                        ></v-text-field>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 md12>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <v-textarea
                          solo
                          v-bind:disabled="sended"
                          v-bind:label="getString('Messaggio')"
                          v-model="message"
                        ></v-textarea>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg5>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <label>{{getString('Per cortesia, indica come ci hai conoscito')}}</label>
                        <v-select
                          solo
                          color="#212121"
                          v-bind:disabled="sended"
                          v-model="select"
                          :items="knowledge"
                          v-bind:label="getString('Come ci hai conosciuto?')"
                        ></v-select>
                      </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg12>
                      <v-container style="padding-bottom:0; padding-top:0;">
                        <label
                          v-html="getString(`Qui trovi i <a href='/legal/tec'>Termini e Condizioni</a> per il trattamento dati. Leggili ed accetta per inviare il messaggio in piena consapevolezza.`)"
                        ></label>
                        <v-checkbox
                          :label="getString('Accetto')"
                          v-model="accept"
                          v-bind:disabled="sended"
                        ></v-checkbox>
                      </v-container>
                    </v-flex>
                    <v-flex xs12>
                      <div style="margin-left:25px" id="g-recaptcha"></div>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-card-actions>
                  <v-container>
                    <v-btn
                      v-if="!sended"
                      :disabled="!valid"
                      @click="sendForm()"
                      class="q-orange"
                    >{{getString('Invia')}}</v-btn>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </section>
        <section style="margin-top:20px;" v-if="notSafari" id="video">
          <div class="rwd-video">
            <iframe
              src="https://www.youtube.com/embed/tVFcjSBS_1U"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </section>
        <div style="text-align:center">
          <v-btn
            class="m-button"
            @click="goToReg"
          >{{getString("REGISTRATI GRATIS")}}</v-btn>
        </div>
      </v-content>
      <v-footer dark height="auto" class=".footer">
        <v-card class="flex" flat tile>
          <v-card-title class="q-orange-bk">
            <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
            <v-spacer></v-spacer>
            <v-btn
              v-for="icon in icons"
              :key="icon.ic"
              class="mx-3"
              dark
              icon
              @click="navigate(icon.url)"
            >
              <v-icon size="24px">{{ icon.ic }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="grey darken-3 justify-center" style="text-align:center">
            &copy; 2018 - &copy;{{(new Date()).getFullYear()}} — &nbsp;
            <strong>Dew Studio</strong> &nbsp; — &nbsp;
            <a href="tel:08118096075">Tel. 081 180 96 075</a> &nbsp; — &nbsp;
            <a
              :title="getString('Vai a Plaza')"
              href="https://plaza.quickbe.app"
            >{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
            <router-link
              :title="getString('Trattamento dei dati')"
              to="/legal/tec"
            >{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
            <router-link
              :title="getString('Uso dei cookies')"
              to="/legal/cookie"
            >{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
            <router-link
              :title="getString(`Condizioni licenza`)"
              to="/legal/eula"
            >{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
            <router-link to="/admin/login">{{getString('Portale')}}</router-link>
          </v-card-text>
        </v-card>
      </v-footer>
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card class="q-whitesmoke-bk black--text" dark>
          <v-card-text>
            {{getString('Invio in corso')}}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSuccess" hide-overlay persistent width="300">
        <v-card class="green lighten-3" dark>
          <v-card-text>
            <h4>{{getString('Inviato con successo')}}</h4>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogError" hide-overlay persistent width="300">
        <v-card class="red lighten-1" dark>
          <v-card-text>
            <h4>{{getString('Errore nell\'invio, riprova più tardi')}}</h4>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogErrorMissing" hide-overlay persistent width="300">
        <v-card class="red lighten-1" dark>
          <v-card-text>
            <h4>{{getString('Campi mancanti')}}</h4>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Your customer chat code -->
      <div
        class="fb-customerchat"
        attribution="setup_tool"
        page_id="1391355074298712"
        theme_color="#d5725b"
      ></div>
    </v-app>
  </div>
  <!-- fb chat -->
</template>

<script>
window.fbAsyncInit = function() {
  FB.init({
    appId: "facebook-developer-app-id",
    autoLogAppEvents: true,
    xfbml: true,
    version: "v2.11"
  });
};

import ajax from "../../ajax";
import Utils from "../../utils";
import HeaderP from "./Header";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import CookieLaw from "vue-cookie-law";
import { isMobileOnly, isAndroid } from 'mobile-device-detect';
let ut = new Utils();
export default {
  name: "Home",
  components: {
    HeaderP,
    swiper,
    swiperSlide,
    CookieLaw
  },
  destroyed: function() {
    if (this.captchaHandler !== null) clearInterval(this.captchaHandler);
  },
  mounted: function() {
    let self = this;
    /* if (isAndroid && isMobileOnly)
    {
      this.openOtherSite = true;
      location.href = "https://www.presenze-online.it/privacy/privacy.html";
      document.body.innerHTML = "";
    }
    else
    { */
      this.initFb(document, "script", "facebook-jssdk");
      this.myPixel = this.initPixel(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');    
      this.myPixel('init', '551676001909516');
      this.myPixel('track', 'PageView');
      self.captchaHandler = setInterval(function() {
        if (typeof window.grecaptcha !== "undefined") {
          if (window.grecaptcha) {
            if (typeof window.grecaptcha !== "function") {
              this.rcapt_id = grecaptcha.render(
                document.getElementById("g-recaptcha"),
                {
                  sitekey: self.rcapt_sig_key,
                  callback: self.reCallback
                }
              );
              clearInterval(self.captchaHandler);
            }
          }
        }
      }, 200);
      var message = this.$route.query.rd;
      if (message !== undefined) {
        this.$router.push("/admin/login");
      }
      this.getShops();
    /* } */
  },
  computed: {
    notSafari: function(){
      const result = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
      console.log(!result);
      return !result;
    },
    printCurrentPage: function() {
      return "QuickBe - " + this.getString("Sistema di prenotazioni");
    },
    compItemsMonth: function() {
      let temp = [];
      temp.push({
        header: this.getString("Gratis!")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("--------")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("--------")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("--------")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Massimo <b>2</b> dipendenti")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Massimo <b>100</b> prenotazioni mensili")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Massimo <b>2</b> giorni a settimana prenotabili")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString(
          "Sito web <b>gratuito</b> su QuickBe <b>Plaza</b>"
        )
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Supporto E-Mail a <b>7</b> giorni lavorativi")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("<b>Nessun</b> accesso alle DLC  ")
      });
      return temp;
    },
    compItemsSem: function() {
      let temp = [];
      temp.push({
        header: this.getString("Abbonamento")
      });
      temp.push({
        divider: true,
        inset: true
      });
      
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Fino <b>10</b> dipendenti")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Prenotazioni <b>illimitate</b>")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("<b>Tutta</b> la settimana prenotabile")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString(
          "Sito web <b>gratuito</b> su QuickBe <b>Plaza</b>"
        )
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString(
          "Supporto E-Mail e telefonico a <b>3</b> giorni lavorativi"
        )
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Accesso gratis a <b>tutte</b> le DLC FREE")
      });
      return temp;
    },
    compItemsYear: function() {
      let temp = [];
      temp.push({
        header: this.getString("Abbonamento")
      });
      temp.push({
        divider: true,
        inset: true
      });
      
      temp.push({
        title: this.getString("App <b>personalizzata</b>")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Gestione <b>gratuita</b> degli store App")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Fino a <b>10</b> dipendenti")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Prenotazioni <b>illimitate</b>")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("<b>Tutta</b> la settimana prenotabile")
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString(
          "Sito web <b>gratuito</b> su QuickBe <b>Plaza</b>"
        )
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString(
          "Supporto E-Mail e telefonico in <b>1</b> giorno lavorativo"
        )
      });
      temp.push({
        divider: true,
        inset: true
      });
      temp.push({
        title: this.getString("Accesso gratis a <b>tutte</b> le DLC FREE")
      });
      return temp;
    },
    options() {
      return {
        duration: 800,
        offset: -60,
        easing: "easeInOutCubic"
      };
    },
    nameRules: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    emailRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateEmail(v) || this.getString("Email non valida")
      ];
    },
    knowledge: function() {
      return [
        {
          text: this.getString("Passaparola"),
          value: "w"
        },
        {
          text: this.getString("Motore di ricerca"),
          value: "se"
        },
        {
          text: this.getString("Facebook"),
          value: "fb"
        },
        {
          text: this.getString("Instagram"),
          value: "in"
        },
        {
          text: this.getString("Altro"),
          value: "ot"
        }
      ];
    },
    valid: function() {
      return (
        ut.ValidateEmail(this.email) &&
        this.name !== "" &&
        this.surname !== "" &&
        this.accept &&
        this.select !== null &&
        this.message !== "" &&
        this.rcapt_resp
      );
    },
    swiperOption() {
      return {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: true,
        centeredSlides: true,
        loopedSlides: this.shops.length,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 30
          }
        }
      };
    }
  },
  data: () => {
    return {
      myPixel: null,
      testVis: false,
      captchaHandler: null,
      rcapt_sig_key: "6LfDvHkUAAAAAMb8pSDfibOvAzznCbTlVlw0qEnf",
      rcapt_id: 0, // will be used later
      rcapt_resp: false,
      currentPage: "Home",
      drawer: false,
      icons: [
        {
          ic: "fab fa-facebook",
          url: "https://www.facebook.com/QuickBeApp/"
        },
        {
          ic: "fab fa-instagram",
          url: "https://www.instagram.com/quickbeapp/"
        }
      ],
      name: "",
      surname: "",
      email: "",
      shop: "",
      accept: false,
      type: "w",
      message: "",
      select: null,
      dialog: false,
      sended: false,
      dialogError: false,
      dialogSuccess: false,
      dialogErrorMissing: false,
      shops: [],
      openOtherSite : false
    };
  },
  methods: {
    goToReg: function()
    {  
      try {
        console.log(this.myPixel);
        this.myPixel.fbq("track","InitateCheckout");
       // this.myPixel("track", "InitiateCheckout");
      } catch (err) {
        
      }
      this.$router.push({path:'/registration'});
    },
    initPixel: function(f, b, e, v, n, t, s) {
      if (f.fbq) return f.fbq;
      n = f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
      return f.fbq;
    },

    initFb: function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/it_IT/sdk/xfbml.customerchat.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    visibilityChange: function(v, e) {
      this.testVis = v;
    },
    getShops: function() {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/shops", {
          withCredentials: true
        })
        .then(response => {
          self.shops = response.data.data;
        })
        .catch(respnse => {});
    },
    navigate: function(url) {
      window.open(url);
    },
    reCallback: function(response) {
      this.rcapt_resp = true;
    },
    goToPlaza: function() {
      location.href = "https://plaza.quickbe.app";
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    scroll: function(myTarget) {
      this.$vuetify.goTo(myTarget, this.options);
    },
    captchaCallback: function(response) {},
    sendForm: function() {
      let self = this;
      if (this.valid) {
        this.dialog = true;
        ajax.axios
          .post(ajax.baseUrl() + "/requestinfo", {
            name: this.name,
            surname: this.surname,
            how: this.select,
            email: this.email,
            message: this.message,
            shop: this.shop
          })
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.dialog = false;
            self.dialogSuccess = true;
            self.sended = true;
            setTimeout(function() {
              self.dialogSuccess = false;
            }, 4000);
            self.myPixel("track","Lead");
          })
          .catch(function(error) {
            self.dialog = false;
            self.dialogError = true;
            setTimeout(function() {
              self.dialogError = false;
            }, 4000);
            console.log(error);
          });
      } else {
        self.dialog = false;
        self.dialogErrorMissing = true;
        setTimeout(function() {
          self.dialogErrorMissing = false;
        }, 2000);
      }
    }
  }
};
</script>

<style scoped>
.v-list__tile__title {
  text-align: center !important;
}

.q-orange-bk-image {
  background-image: url("~/../../../static/img/texture.jpg");
  background-size: cover;
}

.border-white {
  border: 3px solid;
  border-radius: 45px;
}

.free-bk {
  background-color: #679fad !important;
}

.silver-bk {
  background-color: #727077 !important;
}
.primary-color {
  color: #d5725b;
}
.platinum-bk {
  background-color: #d5725b !important;
}
.button-register {
  background-color: #d5725b !important;
  color: #fff;
  font-size: 30px;
}

.service {
  height: 430px;
}

.service .serviceAction {
  position: absolute;
  bottom: 20px;
}

.text-divider {
  margin-bottom: 30px;
  width: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  margin-top: 20px;
  border-width: 2px;
  border-color: #d5725b;
}

.parallax-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 130%;
  height: 100%;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center;
  background-image: url(/static/img/texture.jpg);
}

.card-shop {
  text-align: center;
  padding: 20px;
}

.card-shop img {
  height: 50px;
}
.rwd-video {
  width: 100%;
  text-align: center;
}
.rwd-video iframe,
.rwd-video object,
.rwd-video embed {
  height: 315px;
  width: 560px;
}
.small-card {
  padding: 16px;
}
.padding-0 {
  padding: 0;
}

@media screen and (max-width: 600px) {
  .rwd-video iframe,
  .rwd-video object,
  .rwd-video embed {
    height: 315px;
    width: 100%;
  }
}

@keyframes leftAnim {
  from {
    transform: translateX(-300px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/** MOBILE STUFF */

.header-logo {
  object-fit: cover;
}

.m-header {
  font-weight: 600;
  color: #d5725b;
  font-size: 24px;
  margin-left: 10%;
  margin-right: 10%;
  line-height: 30px;
}
.m-header-alt {
  font-weight: 600;
  color: #679fad;
  font-size: 24px;
  line-height: 30px;
}
.m-subheader {
  font-size: 20px;
  color: #727077;
  font-weight: bold;
  text-align: justify;
  line-height: 30px;
}

.m-header-div {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 10px;
  background: url("../../../static/img/m_img1.png");
  background-size: contain;
  background-position-x: 100%;
  background-repeat: no-repeat;
  border-top: solid 3px #679fad;
  border-bottom: solid 3px #679fad;
}

.m-header-div-orange {
  font-weight: 600;
  color: #d5725b;
  font-size: 18px;
  text-align: left;
  line-height: 20px;
  margin-top: 5px;
}
.m-header-div-gray {
  font-size: 14px;
  color: #727077;
  font-weight: bold;
  line-height: 14px;
}

.m-try-blue {
  display: block;
  color: #679fad;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
}
.m-try-orange {
  display: block;
  color: #d5725b;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: bold;
}
.m-button {
  background-color: #d5725b !important;
  font-size: 25px;
  font-weight: bold;
  color: whitesmoke !important;
  border-radius: 10px;
  height: 50px;
}
.m-icon-row {
  display: inline-block;
  margin-bottom: 25px;
}
.m-icon-container {
  padding-top: 30px;
  padding-left: 10px;
  padding-right: 10px;
}
.m-uppercase {
  text-transform: uppercase;
}
.m-icon-ext {
  float: left;
  width: 20%;
  height: 20%;
  background: #d5725b;
  color: whitesmoke !important;
  border-radius: 50%;
}
.m-icon-text {
  width: 78%;
  padding-left: 10px;
  text-align: left;
  display: inline-block;
  line-height: 16px;
}

.m-hand-container {
  margin-top: 30px;
  background: url("../../../static/img/m_img.png");
  background-position-x: 0%;
  background-size: 45%;
  background-repeat: no-repeat;
}

.m-hand-text {
  width: 50%;
  float: right;
  text-align: right;
  font-size: 16px;
  color: #d5725b;
  font-weight: bold;
  margin-bottom: 20px;
}

.m-hand-text-1 {
  width: 50%;
  float: right;
  text-align: right;
  font-size: 16px;
  color: #727077;
}
.m-app {
  margin-top: 30px;
  margin-bottom: 30px;
}
.m-header-1 {
  margin-top: 30px;
  font-weight: 600;
  color: #d5725b;
  font-size: 24px;
  line-height: 30px;
}

.m-moon-container {
  margin-top: 30px;
  background: url("../../../static/img/m_img2.png");
  background-position-x: 0%;
  background-size: 50%;
  background-repeat: no-repeat;
  margin-bottom: 30px;
}

.m-moon-text {
  width: 50%;
  float: right;
  text-align: left;
  font-size: 16px;
  color: #679fad;
  font-weight: bold;
  padding: 15px;
}

.m-moon-text-1 {
  width: 50%;
  float: right;
  text-align: left;
  font-size: 16px;
  color: #727077;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/Home.vue